import { defineMessages } from 'react-intl';

export const jobPerksTranslations = defineMessages({
    mood: {
        id: 'Developer.JobPerks.mood',
        defaultMessage: 'Great ambiance'
    },
    challenge: {
        id: 'Developer.JobPerks.challenge',
        defaultMessage: 'Challenge'
    },
    salary: {
        id: 'Developer.JobPerks.salary',
        defaultMessage: 'Salary'
    },
    work_hours: {
        id: 'Developer.JobPerks.work_hours',
        defaultMessage: 'Flexible work hours'
    },
    training: {
        id: 'Developer.JobPerks.training',
        defaultMessage: 'Training'
    },
    responsabilities: {
        id: 'Developer.JobPerks.resopnsabilities',
        defaultMessage: 'Responsibilities'
    },
    perks: {
        id: 'Developer.JobPerks.perks',
        defaultMessage: 'Perks (meal, tickets,... )'
    },
    others: {
        id: 'Developer.JobPerks.other',
        defaultMessage: 'Other'
    }
});
